export const PRESET_MESSAGES = [
  'Feliz cumpleaños 🎂',
  'Con mucho cariño ❤️',
  'Disfruta esta experiencia ✨',
  'Gracias por ser increíble 🌟',
];

export const MAX_MESSAGE_LENGTH = 200;
